module.exports = __webpack_public_path__ + "img/hero-2026.be5a11aa.svg";